import type { WallShape } from '@walls/store';
import { hexToRgba } from '../utils/color';
import { getLineAttributes } from '../utils/shapeAttributes';

export function drawLine(
  context: CanvasRenderingContext2D,
  shape: WallShape,
  selected: boolean,
  editable = selected
) {
  const attributes = getLineAttributes(shape);

  context.setLineDash([0]);
  context.beginPath();
  context.moveTo(Math.floor(attributes.startX), Math.floor(attributes.startY));
  context.lineTo(Math.floor(attributes.endX), Math.floor(attributes.endY));
  context.lineWidth = Math.floor(attributes.lineThickness);
  context.strokeStyle = hexToRgba(attributes.lineColor, attributes.lineOpacity);
  context.stroke();

  if (selected && editable) {
    drawHandle(context, attributes.startX, attributes.startY);
    drawHandle(context, attributes.endX, attributes.endY);
  }
}

function drawHandle(context: CanvasRenderingContext2D, x: number, y: number) {
  context.lineWidth = 2;
  context.strokeStyle = '#7dc9fb';
  context.beginPath();
  context.arc(x, y, 5, 0, 2 * Math.PI, false);
  context.stroke();
}
